export type VoiceAgentVariableDirection = 'inbound' | 'outbound';

export type VoiceAgentVariablesFormShape = {
  inbound?: Record<string, string>;
  outbound?: Record<string, string>;
};

function parseVariableMap(raw: unknown): Record<string, string> | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (typeof value === 'string') {
      out[key] = value;
    } else if (typeof value === 'number' || typeof value === 'boolean') {
      out[key] = String(value);
    }
  }
  return Object.keys(out).length > 0 ? out : undefined;
}

export function parseVariablesFromApi(data: unknown): VoiceAgentVariablesFormShape | undefined {
  if (!data || typeof data !== 'object') return undefined;
  const root = data as Record<string, unknown>;
  if (!('variables' in root)) return undefined;
  const variablesRaw = root.variables;
  if (!variablesRaw || typeof variablesRaw !== 'object') return undefined;

  const variables = variablesRaw as Record<string, unknown>;
  const inbound = parseVariableMap(variables.inbound);
  const outbound = parseVariableMap(variables.outbound);
  if (!inbound && !outbound) {
    return { inbound: {}, outbound: {} };
  }
  return {
    inbound: inbound ?? {},
    outbound: outbound ?? {},
  };
}

export function emptyVoiceAgentVariables(): VoiceAgentVariablesFormShape {
  return { inbound: {}, outbound: {} };
}

export function sanitizeVariablesForApi(
  variables: VoiceAgentVariablesFormShape | undefined
): VoiceAgentVariablesFormShape | undefined {
  if (variables == null) return undefined;
  return {
    inbound: variables.inbound ? { ...variables.inbound } : {},
    outbound: variables.outbound ? { ...variables.outbound } : {},
  };
}

export function getVariablesForDirection(
  variables: VoiceAgentVariablesFormShape | undefined,
  direction: VoiceAgentVariableDirection
): Record<string, string> {
  const directionMap = variables?.[direction];
  return directionMap ? { ...directionMap } : {};
}
